/* eslint-disable max-len */
import { createActions } from 'redux-actions';

const actions = createActions({
  APPLY_ALL_POLICIES_CHECK_CHANGED: (data) => data,
  BILLING_INFO_LOAD_FAILED: (data) => data,
  BILLING_INFO_LOADED: (data) => data,
  BILLING_PAYMENT_RESETED: () => { },
  CHANGE_REIMBURSEMENT_ACCOUNT_NUMBER: (data) => data,
  CHANGE_REIMBURSEMENT_ACCOUNT_TYPE: (data) => data,
  CHANGE_REIMBURSEMENT_CARE_CREDIT_NUMBER: (data) => data,
  CHANGE_REIMBURSEMENT_CONFIRM_ACCOUNT_NUMBER: (data) => data,
  CHANGE_REIMBURSEMENT_EXPIRATION_DATE: (data) => data,
  CHANGE_REIMBURSEMENT_FIRST_NAME: (data) => data,
  CHANGE_REIMBURSEMENT_LAST_NAME: (data) => data,
  CHANGE_REIMBURSEMENT_METHOD_TYPE: (data) => data,
  CHANGE_REIMBURSEMENT_ROUTING_NUMBER: (data) => data,
  CHANGE_REIMBURSEMENT_SECONDARY_METHOD_TYPE: (data) => data,
  CHANGE_ROUTING_NUMBER_ERROR: (data) => data,
  CHANGE_SECONDARY_REIMBURSEMENT_ACCOUNT_NUMBER: (data) => data,
  CHANGE_SECONDARY_REIMBURSEMENT_ACCOUNT_TYPE: (data) => data,
  CHANGE_SECONDARY_REIMBURSEMENT_CONFIRM_ACCOUNT_NUMBER: (data) => data,
  CHANGE_SECONDARY_REIMBURSEMENT_ROUTING_NUMBER: (data) => data,
  CHANGE_SECONDARY_REIMBURSEMENT_TO_EXISTING: (data) => data,
  CLOSE_EDIT_REIMBURSEMENT_METHOD_MODAL: (data) => data,
  CONVERT_MONERIS_TICKET: (data) => data,
  GET_ALL_BRANDS_DATA: () => { },
  GET_ALL_BRANDS_DATA_FAILED: () => { },
  GET_ALL_BRANDS_DATA_LOADED: (data) => (data),
  GET_MONERIS_TICKET: (data) => data,
  GET_ORCA_CUSTOMER_VALUES: (data) => data,
  GET_ORCA_CUSTOMER_VALUES_LOADED: (data) => data,
  GET_STRIPE_KEY: (data) => (data),
  LOAD_BILLING_INFO_ALL_BRAND: () => { },
  LOAD_PAYMENT_HISTORY: (data) => data,
  LOAD_PLAN_SUMMARY_DETAILS: (data) => data,
  LOAD_POLICY_DETAILS: (data) => data,
  LOAD_REIMBURSEMENT_METHOD: (data) => data,
  MONERIS_TICKET_FAILED: (data) => data,
  MONERIS_TICKET_LOADED: (data) => data,
  MONERIS_TICKET_RESET: () => { },
  OPEN_ADD_REIMBURSEMENT_METHOD_MODAL: (data) => data,
  PAYMENT_HISTORY_CLEARED: () => { },
  PAYMENT_HISTORY_LOAD_FAILED: (data) => data,
  PAYMENT_HISTORY_LOADED: (data) => data,
  PAYMENT_METHOD_ACCOUNT_NUMBER_CHANGED: (data) => data,
  PAYMENT_METHOD_ACCOUNT_NUMBER_CONFIRMATION_CHANGED: (data) => data,
  PAYMENT_METHOD_ACCOUNT_NUMBER_CONFIRMATION_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_ACCOUNT_NUMBER_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_ACCOUNT_TYPE_CHANGED: (data) => data,
  PAYMENT_METHOD_CARD_NUMBER_CHANGED: (data) => data,
  PAYMENT_METHOD_CARD_NUMBER_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_CITY_CHANGED: (data) => data,
  PAYMENT_METHOD_CITY_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_CVV_NUMBER_CHANGED: (data) => data,
  PAYMENT_METHOD_CVV_NUMBER_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_DATA_CLEARED: () => { },
  PAYMENT_METHOD_EDIT_MODAL_VISIBLE_CHANGED: (data) => data,
  PAYMENT_METHOD_ERROR_MODAL_VISIBLE_CHANGED: (data) => data,
  PAYMENT_METHOD_EXPIRATION_DATE_CHANGED: (data) => data,
  PAYMENT_METHOD_EXPIRATION_DATE_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_FIRST_NAME_CHANGED: (data) => data,
  PAYMENT_METHOD_FIRST_NAME_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_LAST_NAME_CHANGED: (data) => data,
  PAYMENT_METHOD_LAST_NAME_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_PAST_DUE_MODAL_VISIBLE_CHANGED: (data) => data,
  PAYMENT_METHOD_PAYMENT_METHOD_TYPE_CHANGED: (data) => data,
  PAYMENT_METHOD_ROUTING_NUMBER_CHANGED: (data) => data,
  PAYMENT_METHOD_ROUTING_NUMBER_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_STATE_CHANGED: (data) => data,
  PAYMENT_METHOD_STATE_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_STREET_ADDRESS_CHANGED: (data) => data,
  PAYMENT_METHOD_STREET_ADDRESS_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_STREET_ADDRESS2_CHANGED: (data) => data,
  PAYMENT_METHOD_STREET_ADDRESS2_ERROR_CHANGED: (data) => data,
  PAYMENT_METHOD_SUCCESS_MODAL_VISIBLE_CHANGED: (data) => data,
  PAYMENT_METHOD_UPDATE_ATTEMPTED: () => { },
  PAYMENT_METHOD_UPDATED: (data) => data,
  PAYMENT_METHOD_ZIP_CODE_CHANGED: (data) => data,
  PAYMENT_METHOD_ZIP_CODE_ERROR_CHANGED: (data) => data,
  PET_SELECTED: (data) => data,
  POLICY_DETAILS_BENEFITS_LOADED: (data) => data,
  POLICY_DETAILS_LOAD_FAILED: (data) => data,
  POLICY_DETAILS_LOADED: (data) => data,
  POLICY_SELECTED: (data) => data,
  REIMBURSEMENT_METHOD_ERROR_CLEARED: () => { },
  REIMBURSEMENT_METHOD_LOADED: (data) => data,
  REIMBURSEMENT_METHOD_ROUTING_VALIDATION_FAILED: (data) => data,
  REIMBURSEMENT_METHOD_UPDATE_FAILED: (data) => data,
  REIMBURSEMENT_METHOD_UPDATE_RESET: () => { },
  REIMBURSEMENT_METHOD_UPDATED: () => { },
  STRIPE_CLIENT_SECRET_FAILED: (data) => data,
  STRIPE_CLIENT_SECRET_LOADED: (data) => data,
  STRIPE_CLIENT_SECRET_RESET: () => { },
  STRIPE_ERROR_ATTEMPT: (data) => data,
  STRIPE_INITIAL_DATA_LOADED: () => { },
  STRIPE_KEY_FAILED: (data) => data,
  STRIPE_KEY_LOADED: (data) => data,
  STRIPE_UPDATE_PAYMENT_METHOD_ERROR: (data) => data,
  UPDATE_PAYMENT_METHOD: (data) => data,
  UPDATE_PAYMENT_METHOD_CA: (data) => data,
  UPDATE_PAYMENT_METHOD_CA_COMPLETED: () => { },
  UPDATE_PAYMENT_METHOD_CA_ERROR: (data) => data,
  UPDATE_PAYMENT_METHOD_CA_RESET: () => { },
  UPDATE_PAYMENT_METHOD_CA_SYNC: (data) => data,
  UPDATE_REIMBURSEMENT_METHOD: (data) => data,
});

export const {
  applyAllPoliciesCheckChanged,
  billingInfoLoaded,
  billingInfoLoadFailed,
  billingPaymentReseted,
  changeReimbursementAccountNumber,
  changeReimbursementAccountType,
  changeReimbursementCareCreditNumber,
  changeReimbursementConfirmAccountNumber,
  changeReimbursementExpirationDate,
  changeReimbursementFirstName,
  changeReimbursementLastName,
  changeReimbursementMethodType,
  changeReimbursementRoutingNumber,
  changeReimbursementSecondaryMethodType,
  changeRoutingNumberError,
  changeSecondaryReimbursementAccountNumber,
  changeSecondaryReimbursementAccountType,
  changeSecondaryReimbursementConfirmAccountNumber,
  changeSecondaryReimbursementRoutingNumber,
  changeSecondaryReimbursementToExisting,
  closeEditReimbursementMethodModal,
  convertMonerisTicket,
  getAllBrandsData,
  getAllBrandsDataFailed,
  getAllBrandsDataLoaded,
  getMonerisTicket,
  getOrcaCustomerValues,
  getOrcaCustomerValuesLoaded,
  getStripeKey,
  loadBillingInfoAllBrand,
  loadPaymentHistory,
  loadPlanSummaryDetails,
  loadPolicyDetails,
  loadReimbursementMethod,
  monerisTicketFailed,
  monerisTicketLoaded,
  monerisTicketReset,
  openAddReimbursementMethodModal,
  paymentHistoryCleared,
  paymentHistoryLoaded,
  paymentHistoryLoadFailed,
  paymentMethodAccountNumberChanged,
  paymentMethodAccountNumberConfirmationChanged,
  paymentMethodAccountNumberConfirmationErrorChanged,
  paymentMethodAccountNumberErrorChanged,
  paymentMethodAccountTypeChanged,
  paymentMethodCardNumberChanged,
  paymentMethodCardNumberErrorChanged,
  paymentMethodCityChanged,
  paymentMethodCityErrorChanged,
  paymentMethodCvvNumberChanged,
  paymentMethodCvvNumberErrorChanged,
  paymentMethodDataCleared,
  paymentMethodEditModalVisibleChanged,
  paymentMethodErrorModalVisibleChanged,
  paymentMethodExpirationDateChanged,
  paymentMethodExpirationDateErrorChanged,
  paymentMethodFirstNameChanged,
  paymentMethodFirstNameErrorChanged,
  paymentMethodLastNameChanged,
  paymentMethodLastNameErrorChanged,
  paymentMethodPastDueModalVisibleChanged,
  paymentMethodPaymentMethodTypeChanged,
  paymentMethodRoutingNumberChanged,
  paymentMethodRoutingNumberErrorChanged,
  paymentMethodStateChanged,
  paymentMethodStateErrorChanged,
  paymentMethodStreetAddress2Changed,
  paymentMethodStreetAddress2ErrorChanged,
  paymentMethodStreetAddressChanged,
  paymentMethodStreetAddressErrorChanged,
  paymentMethodSuccessModalVisibleChanged,
  paymentMethodUpdateAttempted,
  paymentMethodUpdated,
  paymentMethodZipCodeChanged,
  paymentMethodZipCodeErrorChanged,
  petSelected,
  policyDetailsBenefitsLoaded,
  policyDetailsLoaded,
  policyDetailsLoadFailed,
  policySelected,
  reimbursementMethodErrorCleared,
  reimbursementMethodLoaded,
  reimbursementMethodRoutingValidationFailed,
  reimbursementMethodUpdated,
  reimbursementMethodUpdateFailed,
  reimbursementMethodUpdateReset,
  stripeClientSecretFailed,
  stripeClientSecretLoaded,
  stripeClientSecretReset,
  stripeErrorAttempt,
  stripeInitialDataLoaded,
  stripeKeyFailed,
  stripeKeyLoaded,
  stripeUpdatePaymentMethodError,
  updatePaymentMethod,
  updatePaymentMethodCa,
  updatePaymentMethodCaCompleted,
  updatePaymentMethodCaError,
  updatePaymentMethodCaReset,
  updatePaymentMethodCaSync,
  updateReimbursementMethod,
} = actions;
